// extracted by css-extract-rspack-plugin
export default {"FeaturedListPanel":"FeaturedListPanel-zb1olO","featuredListPanel":"FeaturedListPanel-zb1olO"};